import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import InfoIcon from '../InfoIcon';
import Modal from '@mui/material/Modal';
import { DetailContentModal } from '../SourcesModal';
import { LeftLineCard } from '../LeftLineCard';
import { Stance } from '../../../app/feathers/candidates/Stance';

interface StanceCardProps {
  style?: React.CSSProperties;
  className?: string;
  stance?: Stance;
  candidateId?: string;
  showActions?: boolean;
  showIssueLikes?: boolean;
  awaitingReview?: boolean;
}

const StanceCard: React.FC<StanceCardProps> = ({
  style,
  className,
  stance,
  candidateId,
  showActions = true,
  showIssueLikes = false,
  awaitingReview = false
}) => {
  const [ sourcesModalOpen, setSourcesModalOpen ] = useState(false);

  // Determine if stance is awaiting review based on textApproved field
  const isAwaitingReview = awaitingReview || (stance?.textApproved === false);

  return (
    <LeftLineCard
      style={{
        ...style,
        filter: isAwaitingReview ? 'grayscale(0.5)' : 'none',
      }}
      className={className}
      innerStyle={showActions ? { padding: '16px 16px 8px 16px' } : undefined}
    >
      <Typography 
        variant='body1' 
        color={isAwaitingReview ? 'textSecondary' : 'textPrimary'} 
        style={{ width: '100%' }}
      >
        {stance?.text}
      </Typography>
      {
        showActions &&
        <>
          <StanceFooter>
            <div />
            <div style={{ cursor: 'pointer'}} onClick={() => setSourcesModalOpen(true)}>
              <InfoIconStyled style={{ height: '20px', width: '20px' }}/>
            </div>
          </StanceFooter>
          <Modal
            open={Boolean(sourcesModalOpen)}
            onClose={() => setSourcesModalOpen(false)}
          >
            <DetailContentModal
              onClose={() => setSourcesModalOpen(false)}
              stance={stance}
              contentComponent={() => (
                <StanceCard
                  stance={stance}
                  showActions={false}
                  style={{ marginBottom: '24px', marginTop: '8px' }}
                />
              )}
            />
          </Modal>
        </>
      }
    </LeftLineCard>
  )
}

const InfoIconStyled = styled(InfoIcon)`
  cursor: pointer;
  height: 20px;
  width: 20px;
`

const StanceFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export { StanceCard };
